import {Component, inject} from '@angular/core';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';
import {ThemePalette} from '@angular/material/core';

export interface AreYouSureData {
  header: string;
  message: string;
  cancelButtonText: string;
  confirmButtonText: string;
  confirmButtonColor?: ThemePalette;
}

@Component({
    selector: 'app-are-you-sure-dialog',
    templateUrl: './are-you-sure-dialog.component.html',
    styleUrl: './are-you-sure-dialog.component.scss',
    standalone: false
})
export class AreYouSureDialogComponent {
  readonly data = inject<AreYouSureData>(MAT_DIALOG_DATA);
}
